import { proMenuArrNew } from "@/utils/productor";
import { caseMenuArr } from "@/utils/successCase";
const pro = {
  mp: require('@img/mainPage.png'),
  cover: require("@img/shadow.png"),
  menuArr: proMenuArrNew,
};

const successCase = {
  mp: require('@img/mainPage.png'),
  cover: require("@img/shadow.png"),
  menuArr: caseMenuArr,
};

const headerMenus = [
  {
    name: "首页",
    router: "/"
  },
  {
    name: "产品中心",
    router: "/producter?title=产品中心",
    isExpanded: false,
    childs: pro.menuArr
  },
  { 
    name: "合作伙伴",
    router: "/partner"
  },
  {
    name: "成功案例",
    router: "/case?title=成功案例",
    isExpanded: false,
    childs: successCase.menuArr
  },
  { 
    name: "关于我们",
    router: "/aboutUs?title=关于我们",
  },
  {
    name: "联系我们",
    router: "/aboutUs?title=联系我们&className=contact",
    className: "contact",
  },
];

export { pro, headerMenus, successCase }